import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=600414a8&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"
import style0 from "./Registro.vue?vue&type=style&index=0&id=600414a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600414a8",
  null
  
)

export default component.exports